import { createAllowListStore } from "./factories/create-allow-list-store.ts";

export const useGoogleWorkspaceSettingsStore = createAllowListStore({
  storeId: "google-workspace-settings",
  integrationPath: "integrations/google-workspace",
});
